/**
 * You can find a list of available fonts on both iOS and Android here:
 * https://github.com/react-native-training/react-native-fonts
 *
 * If you're interested in adding a custom font to your project,
 * check out the readme file in ./assets/fonts/ then come back here
 * and enter your new font name. Remember the Android font name
 * is probably different than iOS.
 * More on that here:
 * https://github.com/lendup/react-native-cross-platform-text
 *
 * The various styles of fonts are defined in the <Text /> component.
 */
export const typography = {
  /**
   * The primary font.  Used in most places.
   */
  primary: {
    regular: 'Nunito-Regular',
    bold: 'Nunito-Bold',
  },

  /**
   * An alternate font used for perhaps titles and stuff.
   */
  secondary: {
    regular: 'SofiaPro-Bold',
    bold: 'SofiaPro-Bold',
  },
};

/** New fonts as of 17/12/21 */
export const fonts = {
  regular: 'Inter-Regular',
  medium: 'Inter-Medium',
  semibold: 'Inter-SemiBold',
  bold: 'Inter-Bold',
  kalam: 'Kalam-Regular',
};

/** Styled component style */
export const font_variant_styles = {
  h1: {
    regular: `
      font-family: ${fonts.medium};
      font-size: 34px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 34px;
    `,
    bold: `
      font-family: ${fonts.bold};
      font-size: 34px;
    `,
  },
  h2: {
    regular: `
      font-family: ${fonts.medium};
      font-size: 28px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 28px;
    `,
    bold: `
      font-family: ${fonts.bold};
      font-size: 28px;
    `,
  },
  h3: {
    regular: `
      font-family: ${fonts.regular};
      font-size: 22px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 22px;
    `,
    bold: `
      font-family: ${fonts.bold};
      font-size: 22px;
    `,
  },
  p: {
    regular: `
      font-family: ${fonts.regular};
      font-size: 17px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 17px;
    `,
    bold: `
      font-family: ${fonts.bold};
      font-size: 17px;
    `,
  },
  p2: {
    regular: `
      font-family: ${fonts.regular};
      font-size: 15px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 15px;
    `,
    bold: `
      font-family: ${fonts.regular};
      font-size: 15px;
      font-style: italic;
    `,
  },
  caption: {
    regular: `
      font-family: ${fonts.regular};
      font-size: 13px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 13px;
    `,
    bold: `
      font-family: ${fonts.semibold};
      font-size: 13px;
      text-transform: uppercase;
    `,
  },
  caption2: {
    regular: `
      font-family: ${fonts.regular};
      font-size: 11px;
    `,
    semibold: `
      font-family: ${fonts.semibold};
      font-size: 11px;
    `,
    bold: `
      font-family: ${fonts.medium};
      font-size: 11px;
      text-transform: uppercase;
    `,
  },
  stickyNote: {
    regular: `
      font-family: ${fonts.kalam};
      font-size: 32px;
    `,
    semibold: `
      font-family: ${fonts.kalam};
      font-size: 32px;
    `,
    bold: `
      font-family: ${fonts.kalam};
      font-size: 32px;
    `,
  },
  stickyNote2: {
    regular: `
      font-family: ${fonts.kalam};
      font-size: 22px;
    `,
    semibold: `
      font-family: ${fonts.kalam};
      font-size: 22px;
    `,
    bold: `
      font-family: ${fonts.kalam};
      font-size: 22px;
    `,
  },
};

export type FontVariants = keyof typeof font_variant_styles;
export type FontWeights = keyof typeof font_variant_styles[FontVariants];
